export class AutocompleteSettingsModel {
    private _dataSet = [];
    get DataSet() {
        return this._dataSet;
    }
    set DataSet(newDataSet) {
        this._dataSet.length = 0;
        newDataSet.forEach((item) => this._dataSet.push(item));
    }

    Groups = [
        {
            title: undefined,
            DataSet: this.DataSet,
        },
    ];
    DataTextField = 'Name';
    SelectedTextField = 'NameSelected';
    DataValueField = 'Id';
    FilterBy = null; //Specify property name to filter by. Not specified = filter by all properties
    EnableScroll = true;
    IsEnabled = true;
    Localization = {
        //Should these be customizable or should the directive always fetch from the global Localization
        Empty: '',
        NoSelectedItems: '',
    };

    AddItem = () => {};

    OrderBy = true;
}
